import React from 'react'
import { useTranslation } from 'react-i18next'

import RadioBlock from '../../../../../components/Form/RadioBlock'
import MultiSelectBox from '../../../../../features/components/Form/MultiSelectBox'

import { OPTION_NO, OPTION_YES } from '../../../../../constants/forms'
import { AUDIENCES_OPTION, CUSTOM_AUDIENCES } from '../fields'

const AudienceSelectionRadioBlocks = ({ formik, audiencesIsLoading, formattedAudiences }) => {
  const { t } = useTranslation()

  const { values, errors, touched, setFieldValue } = formik
  const customAudiencesError = errors[CUSTOM_AUDIENCES]
  const customAudiencesTouched = touched[CUSTOM_AUDIENCES]

  return (
    <>
      <RadioBlock
        setFieldValue={setFieldValue}
        id="radio_audiences_option_yes"
        name={AUDIENCES_OPTION}
        value={OPTION_YES}
        selectedValue={values[AUDIENCES_OPTION]}
        label={t('Yes')}
        error={customAudiencesError}
        touched={customAudiencesTouched}
      >
        <MultiSelectBox
          placeholder={t('Add an audience')}
          options={formattedAudiences}
          name={CUSTOM_AUDIENCES}
          value={values[CUSTOM_AUDIENCES]}
          isLoading={audiencesIsLoading}
          setFieldValue={setFieldValue}
        />
      </RadioBlock>
      <RadioBlock
        setFieldValue={setFieldValue}
        id="radio_audiences_option_no"
        name={AUDIENCES_OPTION}
        value={OPTION_NO}
        selectedValue={values[AUDIENCES_OPTION]}
        label={t('No')}
      />
    </>
  )
}

export default AudienceSelectionRadioBlocks
